import axios from 'axios';
import { loginService } from './LoginService';

export const receptionsService={
    getReceptions,
    getReception,
    searchReception
}
function getReceptions( pageNumber) {
    let url = `${process.env.REACT_APP_API_URL}/api/receipts?page[number]=${pageNumber ? pageNumber : 1}`;

    const requestOptions = {
      method: 'GET',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }

    return axios(requestOptions);
  }
  function getReception(receiptId, pageNumber) {
    let url = `${process.env.REACT_APP_API_URL}/api/receipt_items?page[number]=${pageNumber ? pageNumber : 1}&receipt_id=${receiptId}`;

    const requestOptions = {
      method: 'GET',
      url,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
    if (loginService.loggedIn()) {
      requestOptions.headers['Authorization'] = loginService.getToken();
    }

    return axios(requestOptions);
  }

  function searchReception(searchNumber, pageNumber) {
    let url = `${process.env.REACT_APP_API_URL}/api/receipts/search?page[number]=${
      pageNumber ? pageNumber : 1
    }${searchNumber ? `&search_number=${searchNumber}` : '' }`;

    const requestOptions = {
        method: 'GET',
        url,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json'
        }
      };
      if (loginService.loggedIn()) {
        requestOptions.headers['Authorization'] =loginService.getToken();
      }

      return axios(requestOptions);
  }
